'use strict';

// Pull in the styles ...
import './main/scss/main.scss';

import React from 'react';
import {HashRouter, Navigate, Route, Routes} from 'react-router-dom';

import App from '@uw-it-sis/lib-react/lib/App';
import Header from '@uw-it-sis/lib-react-myplan/lib/Header';
import Footer from '@uw-it-sis/lib-react-myplan/lib/Footer';
import {AppContext} from '@uw-it-sis/lib-react/lib/AppContext';
import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import history from '@uw-it-sis/lib-react/lib/History';
import {render} from '@uw-it-sis/lib-react/lib/Render';

import AppNavigation from '@uw-it-sis/lib-react-myplan/lib/AppNavigation';

import Bookmarks from './main/js/bookmarks/Bookmarks';
import CourseDetails from './main/js/cdp/CourseDetails';
import CourseSearch from './main/js/search/CourseSearch';

/**
 * Define the routes.
 */
const routes =
    <Routes>
        <Route path="courses" element={<CourseSearch />} />
        <Route path="bookmarks" type="bookmarks" element={<Bookmarks />}/>
        <Route path="courses/:courseCode" element={<CourseDetails />}/>
        <Route path="" element={<Navigate to="courses" replace={true} />} />
    </Routes>;

/**
 * Put the AppStore in the React context so that it's available to any class that needs it.
 * Provide appStore and browser history in the context.
 */
const router = (
    <AppContext.Provider value={
        {
            appStore: appStore,
            history: history
        }
    }>
        <HashRouter>
            <App name={"course"}
                 title="UW MyPlan"
                 routes={routes}
                 header={<Header />}
                 footer={<Footer />}
                 navigation={<AppNavigation />}
            />
        </HashRouter>
    </AppContext.Provider>
);

render(router);